import { render, staticRenderFns } from "./PlanEditForm.vue?vue&type=template&id=3bb46aa4"
import script from "./PlanEditForm.vue?vue&type=script&lang=js"
export * from "./PlanEditForm.vue?vue&type=script&lang=js"
import style0 from "./PlanEditForm.vue?vue&type=style&index=0&id=3bb46aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports